export type HomeMode = "loading" | "guided" | "returning" | "partial-error";
export interface HomeSourceState {
  state: "loading" | "success" | "error" | "stale";
  hasWork: boolean;
}
export function selectHomeMode({
  sources,
  onboarding,
  hasConversation,
}: {
  sources: HomeSourceState[];
  onboarding: { dismissed: boolean; completed: boolean; hasDraft: boolean };
  hasConversation: boolean;
}): HomeMode {
  if (
    sources.some((s) => s.hasWork) ||
    onboarding.dismissed ||
    onboarding.completed ||
    hasConversation
  )
    return "returning";
  if (sources.some((s) => s.state === "loading")) return "loading";
  if (sources.some((s) => s.state === "error" || s.state === "stale"))
    return "partial-error";
  return "guided";
}
